<template>
  <div id="app">
    <BlockUI :message="msg" :html="html" v-if="show"></BlockUI>
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-dvr-rtg.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>
export default {
  name: 'app',
  data: () => ({
    show: false,
    msg: 'Enviando...',
    html: '<i class="fas fa-circle-notch fa-spin fa-3x"></i>'
  }),
  created () {
    this.$root.$on('Spinner::show', () => { this.show = true })
    this.$root.$on('Spinner::hide', () => { this.show = false })
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  }
}
</script>

<style lang="scss">
.loading-container {
  .loading-backdrop {
    background-color: rgb(138, 138, 138);
    //the backdrop falls in here, you can override the opacity etc.
  }
  .loading {
    padding: 60px 90px !important;
    .loading-icon {
      color: #2f83ba
      //the image or inserted html will be put here
    }
    .loading-label {
      //the label showing on loading screen
    }
  }
}
</style>
